import { render, staticRenderFns } from "./vModifyIngredientCost.vue?vue&type=template&id=eff3949c&scoped=true"
import script from "./vModifyIngredientCost.vue?vue&type=script&setup=true&lang=ts"
export * from "./vModifyIngredientCost.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./vModifyIngredientCost.vue?vue&type=style&index=0&id=eff3949c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff3949c",
  null
  
)

export default component.exports